import {
    Box,
    Button,
    HStack,
    Popover,
    PopoverBody,
    PopoverContent,
    PopoverTrigger,
    Portal,
    Stack,
  } from '@mybridge/ui';
  import { forwardRef, useEffect, useRef } from 'react';
  import { useDisclosure } from '@mybridge/ui';
  import { CloseBlueIcon } from '@mybridge/icons';
  import { useOutsideClick } from '@mybridge/ui';
  import styles from './filter-keyword-popover.module.scss';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
import { Heading } from '@chakra-ui/react';
  export const FilterPopoverPopper = forwardRef(
    ({ trigger, children, onPopClose, withForm, isFetching, placement, submitHandler, ...props }, ref) => {
      const { onOpen, onClose, isOpen } = useDisclosure();
      const refElem = useRef();
      const { t } = useTranslator();
      const direction = useDirection();
      const initialFocusRef = useRef();
      useEffect(() => {
        if (isFetching) {
          onOpen();
        }
      }, [isFetching]);
  
    //   useOutsideClick({
    //     ref: refElem,
    //     handler: () => {onClose(); onPopClose(false);},
    //   })
  
      return (
        <Box as="span" ref={refElem} w="100%">
          <Popover
            placement={placement ? placement : "bottom-start"}
            initialFocusRef={initialFocusRef}
            autoFocus={false}
            onOpen={onOpen}
            onClose={onClose}
            isOpen={isOpen}
          >
            {/* {({ isOpen, onClose }) => ( */}
            <>
              <PopoverTrigger ref={initialFocusRef}>{trigger}</PopoverTrigger>
              <Portal>
                <PopoverContent w="auto"   minW="300px" position="relative" data-job-keyword-popup="true">
                <CloseBlueIcon
                  as="button"
                  style={{
                    cursor: 'pointer',
                    position: 'absolute',
                    top: '10px',
                    // right: '10px',
                    ...(direction === 'rtl' 
                      ? { left: '10px' } 
                      : { right: '10px' }
                    ),
                    zIndex: 10,
                    paddingTop:4
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    onClose();
                  }}
                />
                  <PopoverBody shadow="md" p={0}>
                    <Heading
                      pl={4}
                      pt={4}
                      fontSize="18px" 
                      fontWeight="600" 
                      color="brandPrimary.500" 
                    >
                      {t('searchPage.keyword') || 'Keyword'}
                    </Heading>
                    <Stack>
                      <Stack>{children}</Stack>
                      {withForm && (
                        <HStack
                            // pr={"20px"}
                            {...(direction === 'rtl' ? { pl: '20px' } : { pr: '20px' })}
                            pb={"20px"}
                            style={{display: 'flex', justifyContent: 'flex-end'}}
                        >
                          <Button
                            variant="secondary"
                            borderRadius="full"
                            onClick={() => {
                              onClose();
                              onPopClose(false);
                            }}
                            size="md"
                            type="button"
                          >
                            {t('buttons.cancel') || "Cancel"}
                          </Button>
                          <Button onClick={() => submitHandler().then(()=> onClose())} variant="primary" borderRadius="full" size="md">
                            {t('searchPage.showResults') || "Show Results"}
                          </Button>
                        </HStack>
                      )}
                    </Stack>
                  </PopoverBody>
                </PopoverContent>
              </Portal>
            </>
            {/* )} */}
          </Popover>
        </Box>
      );
    }
  );